import React from "react";
import { ISeatDetail } from "../../../../models/trip";

interface SeatPillProps {
  seat:  ISeatDetail;
  onClick?: (seat: ISeatDetail) => void;
  className?: string;
  isSelected?: boolean;
  disabled?: boolean;
}

const SeatPill: React.FC<SeatPillProps> = ({
  seat,
  onClick,
  className = "",
  isSelected = false,
  disabled = false,
}) => {
 const base =
    "relative h-20 rounded-xl flex items-center justify-center border font-medium text-sm mt-[3px] transition-all select-none";
  const statusClasses =
    seat.status === "available"
      ? "bg-emerald-50 border-emerald-200 text-emerald-700"
      : seat.status === "booked" || seat.status === "reserved"
      ? "bg-rose-50 border-rose-200 text-rose-700"
      : "bg-gray-100 border-gray-200 text-gray-600";

  return (
     <button
      type="button"
      disabled={disabled}
      onClick={() => !disabled && onClick && onClick(seat as ISeatDetail)}
      className={` 
  ${base}
  ${statusClasses}
  ${isSelected ? "ring-2 ring-blue-400 shadow-md" : ""}
  ${disabled ? "opacity-40 cursor-not-allowed" : ""}
  ${className}
`}
      title={`Ghế ${seat.seatCode} · ${seat.status}`}
    >
      {isSelected && (
        <span className="absolute top-1 right-1 bg-blue-600 text-white text-xs rounded-full px-1">
          ✓
        </span>
      )}
      <div className="flex flex-col items-center">
        <span className="text-[16px] text-blue-600 font-bold">{seat.seatCode}</span>
        <span className="text-sm opacity-70">
          {seat.status === "available"
            ? "Trống"
            : seat.customerDetail?.shortName || "Đã đặt"}
        </span>
      </div>
    </button>
  );
};

export default SeatPill;
